import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useCallback } from "react";
import classNames from "classnames";
import styles from "./TextInput.module.scss"; // missing DEPRACATGED_TextInput.module.scss as Storybook in not able to resolve it
/**
 * @deprecated use TextInput from @jti/ui instead
 */
export const DEPRECATED_TextInput = forwardRef(({ className, autoComplete = "off", dataTestId = "", formatter, onChange = () => void 0, ...rest }, ref) => {
    const handleChange = useCallback((e) => {
        const _value = formatter ? formatter(e.target.value) ?? "" : e.target.value ?? "";
        onChange({
            ...e,
            target: {
                ...e.target,
                // @ts-expect-error TODO: fix this
                value: _value,
            },
        });
        if (formatter) {
            const caretStart = e.target.selectionStart;
            const caretEnd = e.target.selectionEnd;
            const end = caretEnd + (_value.length !== e.target.value.length ? _value.length - e.target.value.length : 0);
            const start = caretStart === caretEnd ? end : caretStart;
            setTimeout(() => {
                e.target.setSelectionRange(start, end);
            }, 0);
        }
    }, [onChange, formatter]);
    return (_jsx("input", { ...rest, ref: ref, className: classNames(styles.input, className), autoComplete: autoComplete, onChange: handleChange, "data-testid": dataTestId || "" }));
});
//# sourceMappingURL=DEPRECATED_TextInput.js.map